<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="item">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.inscriptions_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="item">Inscripciones : {{ item.fullname }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <v-card>
                                <v-card-title>Registrar a nuevo curso</v-card-title>
                                <v-card-text class="text-center">
                                    Realizar registro a un nuevo curso disponible
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text color="#000" :disabled="courses.length==0" block @click="registration_dialog = !registration_dialog">Registrar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <v-card>
                                <v-card-title>Inscripciones</v-card-title>
                                <v-card-text v-if="new_item.student_courses.length > 0">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Fecha</th>
                                                    <th>Curso</th>
                                                    <th>Estado</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(inscription, index) in new_item.student_courses" :key="index">
                                                    <td>{{ inscription.registration_date }}</td>
                                                    <td>{{ inscription.course.name }}</td>
                                                    <td>
                                                        <v-chip :color="inscription.status ? 'success' : 'error'">
                                                            {{ inscription.status ? 'Actual' : 'pasado' }}
                                                        </v-chip>
                                                    </td>
                                                    <td>
                                                        <template v-if="inscription.status">
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn @click="inscription_id = inscription.id" text icon v-bind="attrs" v-on="on">
                                                                        <v-icon>mdi-close</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Eliminar</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                                <v-card-text v-else>
                                    <p class="text-center">Sin inscripciones registradas</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-dialog v-model="registration_dialog" max-width="800" persistent>
            <v-card>
                <v-card-title>Registrar a nuevo curso</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <v-select v-model="selected_course" return-object :items="courses" item-value="id" item-text="name" filled label="Seleccione el curso"></v-select>
                            </v-col>
                            <v-col v-if="selected_course" cols="12" class="pt-0">
                                <v-card outlined>
                                    <v-card-title>
                                        {{ selected_course.name }}
                                    </v-card-title>
                                    <v-card-text>
                                        <p class="mb-0">Modalidad : <strong>{{ selected_course.modality.name }}</strong></p>
                                        <p class="mb-0">Nivel : <strong>{{ selected_course.level.name }}</strong></p>
                                        <p class="mb-0">Fecha de inicio : <strong>{{ selected_course.start_date }}</strong> </p>
                                        <p class="mb-0">Cantidad de Alumnos : <span :class="selected_course.number_students >= selected_course.student_limit ? 'red--text' : ''">{{ selected_course.number_students }}</span></p>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>Día</th>
                                                        <th>Hora inicio</th>
                                                        <th>Hora final</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(schedule, index) in selected_course.schedule" :key="index">
                                                        <td>{{ schedule.day }}</td>
                                                        <td>{{ schedule.start_time }}</td>
                                                        <td>{{ schedule.end_time }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="() => { registration_dialog = false;  selected_course = '' }" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark :loading="loading" @click="register_course">Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','item','courses'],
    data: () => ({
        //get item
        get_url:"/students/inscriptions",
        new_item:"",

        student:"",
        registration_dialog:false,
        selected_course:"",
        inscription_id:"",
        loading:false,
    }),

    watch:{

        item:function(val){
            axios.get(this.get_url, { params:{ ajax:true, student_id:val.id }}).then(response => {
                this.new_item = response.data.item
            }).catch(err => {

            })
        },

        inscription_id:function(val){
            let data = {}
            data.sbc_id = val
            axios.post('/students/unsubscribe', data).then(response => {
                iziToast.success({
                    title:"Correcto",
                    message:"Inscripción eliminada correctamente",
                    position:"topRight"
                })

                this.$parent.getData()
                this.$parent.inscriptions_dialog = false

            }).catch(error => {
                iziToast.error({
                    title:"Error",
                    message:"ha ocurrido un error en la comunicación con el servidor",
                    position:"topRight"
                })
            })
        }
    },

    methods:{
        register_course: function(){
            if(typeof(this.selected_course) === 'object'){
                this.loading = true

                let data = {}
                data.course_id = this.selected_course.id
                data.user_id = this.item.id
                
                axios.post("/students/register_course", data).then(response => {

                    iziToast.success({
                        title:"Correcto",
                        message:"Inscripción realizada correctamente",
                        position:"topRight"
                    })

                    this.$parent.inscriptions_dialog = false
                    this.$parent.getData()

                }).catch(error => {

                    console.log(error)
                    iziToast.error({
                        title:"Error",
                        message:"ha ocurrido un error en la comunicación con el servidor",
                        position:"topRight"
                    })
                    
                }).then( () => {
                    this.registration_dialog = this.loading = false
                })

            }
        }
    }
}
</script>